import ArrowRight from "@endya-conformite/ui-kit/src/assets/icons/arrow-right.svg?react";
import { Link } from "react-router-dom";
import styles from "./CmsVoirTout.module.scss";

type CmsVoirToutProps = {
  to: string;
};
export function CmsVoirTout({ to }: CmsVoirToutProps) {
  return (
    <div className={styles.container}>
      <Link className={styles.buttonVoirTout} to={to}>
        <span className={styles.arrow}>
          <ArrowRight />
        </span>
        <p>Voir tout</p>
      </Link>
    </div>
  );
}
